export const STORE_LIST = "STORE_LIST";
export const CITIES_WEB = "CITIES_WEB";
export const PICKUP_STORES_LIST = "PICKUP_STORES_LIST";
export const DELIVERY_STORES_LIST = "DELIVERY_STORES_LIST";
export const SELECT_STORE_ID = "SELECT_STORE_ID";
export const SELECT_STORE = "SELECT_STORE";
export const GET_TAX_CASH = "GET_TAX_CASH";
export const GET_TAX_CARD = "GET_TAX_CARD";
export const ACTIVE_STORE = "ACTIVE_STORE";
export const UPDATE_ONLINE_DEL_FEE="UPDATE_ONLINE_DEL_FEE";
export const SAVE_POS_FEE = "SAVE_POS_FEE"